import React, { useState, useEffect } from "react";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar.js";
import DynamicRating from "../../../Common/Rating/Rating";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations.js";
import "./FeedBackList.css";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { get } from "../../../helper/Api_helper.js";
import { VYLABS_BASE_URL, LIST_FEEDBACK } from "../../../helper/url_helper.js";

function FeedbackList() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFeedBacks = async () => {
    try {
      setLoading(true);
      const response = await get(VYLABS_BASE_URL, LIST_FEEDBACK);
      console.log("fetchFeedBacks response:", response);
      if (response && response.feedbacks) {
        const sortedFeedbacks = response.feedbacks.sort(
          (a, b) => new Date(b.lastModified) - new Date(a.lastModified),
        );
        setFeedbacks(sortedFeedbacks);
      } else {
        setFeedbacks([]);
        Toast("info", "No feedback data available.");
      }
    } catch (error) {
      console.error("fetchFeedBacks error:", error);
      setError("Failed to load feedback.");
      Toast("error", "Failed to load feedback.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeedBacks();
  }, []);

  if (loading) {
    return (
      <div className="feedback-loader">
        <VybogTALLoaderAnimation />
      </div>
    );
  }

  if (error) {
    return <div className="feedback-error">{error}</div>;
  }

  return (
    <div className="feedback-container">
      <h2 className="feedback-title">User Feedback</h2>
      {feedbacks.length === 0 ? (
        <p className="feedback-empty">No feedback available.</p>
      ) : (
        <div className="feedback-grid">
          {feedbacks.map((feedback, index) => (
            <div key={feedback.key} className="feedback-card">
              <div className="feedback-badge">#{index + 1}</div>

              <div className="feedback-header">
                <div>
                  <div className="feedback-meta-compact">
                    <span className="meta-item">
                      <strong>Submitted By:</strong>
                      {feedback.user?.first_name || feedback.user?.last_name
                        ? `${feedback.user.first_name || ""} ${
                            feedback.user.last_name || ""
                          }`.trim()
                        : "N/A"}
                    </span>
                    <span className="meta-item">
                      <strong>Company:</strong> {feedback.tenant?.name || "N/A"}
                    </span>
                    <span className="meta-item">
                      <strong>Date:</strong>
                      {new Date(feedback.lastModified).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>

              <div className="feedback-rating">
                <DynamicRating
                  name={`rating-${feedback.key}`}
                  value={feedback.ratings || 0}
                  max={5}
                  precision={1}
                  size="small"
                  filledIcon={<StarIcon fontSize="small" />}
                  emptyIcon={<StarBorderIcon fontSize="small" />}
                  filledColor="#ffd700"
                  hoverColor="#ffc107"
                  emptyColor="#ccc"
                  readOnly
                />
                <span
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    marginLeft: "4px",
                  }}
                >
                  ({feedback.ratings || 0}/5)
                </span>
              </div>
              <div className="feedback-description">
                <h4 className="feedback-subtitle">Remarks</h4>
                <p className="feedback-text">
                  {feedback.feedback_desc || "No remarks provided"}
                </p>
              </div>

              {feedback.screens && feedback.screens.length > 0 && (
                <div className="feedback-images">
                  <h4 className="feedback-subtitle">
                    Attached Images ({feedback.screens.length})
                  </h4>
                  <div className="feedback-image-grid">
                    <PhotoProvider>
                      {feedback.screens.map((url, idx) => (
                        <PhotoView
                          key={idx}
                          src={url}
                          alt={`Feedback screenshot ${idx + 1}`}
                        >
                          <img
                            src={url}
                            alt={`Feedback screenshot ${idx + 1}`}
                            className="feedback-image"
                            style={{ cursor: "pointer" }}
                          />
                        </PhotoView>
                      ))}
                    </PhotoProvider>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FeedbackList;
